import { defineStore } from 'pinia'

export const useLoginErrorStore = defineStore('loginErrorStore', () => {
  const loginErrorMessage = ref('')
  const registerErrorMessage = ref('')

  const clearErrors = () => {
    clearLoginError()
    clearRegisterError()
  }

  const clearLoginError = () => {
    setLoginErrorMessage('')
  }

  const clearRegisterError = () => {
    setRegisterErrorMessage('')
  }

  const setLoginErrorMessage = (message: string) => {
    loginErrorMessage.value = message
  }

  const setRegisterErrorMessage = (message: string) => {
    registerErrorMessage.value = message
  }

  return {
    loginErrorMessage,
    registerErrorMessage,
    clearErrors,
    clearLoginError,
    clearRegisterError,
    setLoginErrorMessage,
    setRegisterErrorMessage,
  }
})
